import type { OrganizationDto } from "@strtmn/sds/types"
import { I18n } from "aws-amplify/utils"
import { useNavigate, useSearchParams } from "react-router-dom"
import { filterOrgs, sortOrgs } from "../../api/OrgsApi"

interface OrgTableProps {
  orgs: OrganizationDto[]
}

export default function OrgTable({ orgs }: OrgTableProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  function redirectToEditOrg(org: OrganizationDto) {
    navigate(`../orgs/${org.id}`)
  }

  if (orgs.length === 0) {
    return <div className="search-result-info">{I18n.get("Keine Daten.")}</div>
  }

  const filter = searchParams.get("filter")?.toLocaleLowerCase()
  const orgsFiltered = filterOrgs(orgs, filter)
  const orgsSorted = sortOrgs(orgsFiltered)

  return (
    <table className="admin-table w-full">
      <thead>
        <tr className="bg-slate-300">
          <th>{I18n.get("Name")}</th>
          <th>{I18n.get("Adresse")}</th>
        </tr>
      </thead>
      <tbody>
        {orgsSorted.map((org, idx) => (
          <tr
            key={org.id}
            className={
              "cursor-pointer " +
              (idx % 2 === 0 ? "bg-slate-100" : "bg-slate-200")
            }
            onClick={() => redirectToEditOrg(org)}
          >
            <td className="pl-2">{org.name}</td>
            <td>
              {!org.address ? (
                <em>{I18n.get("Keine Adresse")}</em>
              ) : typeof org.address === "string" ? (
                org.address
              ) : (
                <>
                  {org.address.street} {org.address.number}
                  <br />
                  {org.address.country} {org.address.zip} {org.address.city}
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
